import {
  UserRole,
  SessionBillingPeriod,
  SessionBooking,
} from "@joonapp/web-shared"

import { createJoonAPIClient } from "../../util/joon-api"

export const getSessionBillingPeriods = async (groupId: number) => {
  const API = createJoonAPIClient()
  const response = await API.get<{ results: SessionBillingPeriod[] }>(
    "/api/session-billing-periods",
    { params: { group_id: groupId } }
  )
  return response.data.results
}

export const getSessionBookings = async (groupId?: number) => {
  const params = groupId ? { group_id: groupId } : {}

  const API = createJoonAPIClient()
  const response = await API.get<{ results: SessionBooking[] }>(
    "/api/session-bookings",
    { params }
  )
  return response.data.results
}

export const getSessionBooking = async (sessionId: number) => {
  const API = createJoonAPIClient()
  const response = await API.get<SessionBooking>(
    `/api/session-bookings/${sessionId}`
  )
  return response.data
}

export const getUpcomingSessions = async () => {
  const API = createJoonAPIClient()
  const response = await API.get<{
    next_sessions: SessionBooking[]
    group_ids_with_sessions: number[]
  }>("/api/session-bookings/next-sessions")
  return response.data
}

export const updateSessionNotes = async ({
  noteId,
  note,
  visibilityRole,
}: {
  noteId: number
  note?: string
  visibilityRole?: UserRole.COACH | null // null sets visibility to public
}) => {
  const API = createJoonAPIClient()
  const response = await API.put(`/api/session-notes/${noteId}/`, {
    note,
    visibility_role: visibilityRole,
  })
  return response.data
}

export const updateSessionBooking = async (
  data: {
    sessionBookingId: number
  } & (
    | { markedNoShow: boolean }
    | { reason: string; hasVerifiedWithAdmin: boolean }
    | { markLateCancel: boolean }
    | { resourceIds: number[] }
  )
) => {
  const API = createJoonAPIClient()
  const response = await API.patch(
    `/api/session-bookings/${data.sessionBookingId}/`,
    {
      marked_no_show: "markedNoShow" in data ? data.markedNoShow : undefined,
      allow_makeup:
        "hasVerifiedWithAdmin" in data ? data.hasVerifiedWithAdmin : undefined,
      makeup_reason: "reason" in data ? data.reason : undefined,
      marked_late_cancellation:
        "markLateCancel" in data ? data.markLateCancel : undefined,
      resource_ids: "resourceIds" in data ? data.resourceIds : undefined,
    }
  )
  return response.data
}
